import _ from "csi/_base/underscore";
import PathMatrix from "csi/table/matrix/Path";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const FoodSourceMatrices = declare(PathMatrix, {

	/**
	 * @override
	 * Filters children nodes of SR by SKU as well as state
	 * For SupplierUserFoodSKUs view only show nodes from SR with SKUs
	 * For other views only show nodes from SR without SKUs
	 */
	_filterNodes (ctx, spec, nodes) {
		const isSkuView = ctx.defView.m_id === "SupplierUserFoodSKUs";

		return _.filter(nodes, (node) => {
			if (node.$Type === "SRLineItem") {
				const requestType = xml.enumGetText(ctx.cache.getNode(node.__Parent__).RequestType);
				return isSkuView === (requestType === "FoodSKU");
			}
			const srLineItem = ctx.cache.getNode(node.$Type === "FoodSupplierItem" ? node.QuoteSRLineItem : node.SampleSRLineItem);
			if (!srLineItem) {
				return false;
			}
			const supplierRequest = ctx.cache.getNode(srLineItem.__Parent__);
			if (!supplierRequest || (isSkuView !== (xml.enumGetText(supplierRequest.RequestType) === "FoodSKU"))) {
				return false;
			}
			const state = xml.enumGetText(supplierRequest.State);
			return (state === "Issued" || state === "Complete");
		});
	},
});

export = FoodSourceMatrices;
